import { GenericNoSubHeaderPage, GenericPage } from "../../../../../pages";
import { atsRoutes } from "./sri-ats.route";

import { facturasRoutes } from "./sri-facturas.route";
import { retencionesRoutes } from "./sri-retentions.route";
import { creditNotesRoutes } from "./sri-credit-notes.route";
import { debitNotesRoutes } from "./sri-debit-notes.route";
import { remissionGuidesRoutes } from "./sri-remission-guides.route";
import { mailLogRoutes } from "./sri-mail-log.route";

export const sriRoutes = [
  {
    path: "invoices",
    element: <GenericPage />,
    children: facturasRoutes,
  },
  {
    path: "retentions",
    element: <GenericPage />,
    children: retencionesRoutes,
  },
  {
    path: "credit-notes",
    element: <GenericPage />,
    children: creditNotesRoutes,
  },
  {
    path: "debit-notes",
    element: <GenericPage />,
    children: debitNotesRoutes,
  },
  {
    path: "remission-guides",
    element: <GenericPage />,
    children: remissionGuidesRoutes,
  },
  {
    path: "ats",
    element: <GenericNoSubHeaderPage />,

    children: atsRoutes,
  },
  {
    path: "mail-log",
    element: <GenericNoSubHeaderPage />,
    children: mailLogRoutes,
  },
];
